<style scoped>
.showButton {
    background-color: white;
    @apply px-2;
}

.bubble-box {
    max-height: calc(100vh - 4rem);
    overflow: auto;
}

.product-detail-content ::v-deep .text-external-urls {
    width: auto;
}

.product-detail-content {
    max-height: 80vh;
    overflow-y: auto;
}

.product-detail-content ::v-deep .product-info-wrapper .product-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

::v-deep .product-info-wrapper {
    max-height: 25vh;
    overflow-y: auto;
}

::v-deep .product-image-wrapper {
    max-width: 200px;
}
</style>

<template>
    <div>
        <button
            class="flex flex-wrap content-center text-primary p-1 hover:opacity-75 focus:outline-none"
            @click="() => (showModal = true)"
        >
            <div class="icon w-8 h-8">
                <eyeSvg />
            </div>
        </button>
        <modal
            type="custom"
            v-if="showModal"
            :showDismiss="true"
            class="modal-xl"
            @backdrop="showModal = false"
        >
            <div
                class="w-full text-center text-lg sm:text-xl font-black border-b border-gray-100 mb-4"
            >
                快速瀏覽
            </div>
            <productDetailContent
                class="product-detail-content"
                :product="product"
                :showProdDespImg="false"
            >
                <template #button>
                    <router-link
                        tag="button"
                        class="btn py-1 px-4 text-secondary bg-white border-secondary"
                        :to="
                            previewCmpyToken
                                ? {
                                      name: 'previewProduct',
                                      params: {
                                          cmpyToken: previewCmpyToken,
                                          id: product.id
                                      }
                                  }
                                : {
                                      name: 'product',
                                      params: { id: product.id }
                                  }
                        "
                    >
                        <div
                            class="flex flex-row items-center justify-center w-full text-sm"
                        >
                            <div class="icon">
                                <eyeSvg />
                            </div>
                            <div class="px-2 text-center">
                                {{ '了解更多' }}
                            </div>
                        </div>
                    </router-link>
                </template>
            </productDetailContent>
        </modal>
    </div>
</template>

<script>
import modal from './modal.vue';
import eyeSvg from '@/assets/svg/eye.svg';
import productDetailContent from './productDetailContent.vue';

export default {
    components: {
        modal,
        eyeSvg,
        productDetailContent
    },
    props: {
        product: { type: Object, required: true }
    },
    data() {
        return {
            showModal: false
        };
    },
    computed: {
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        }
    }
};
</script>
